import { FaHtml5, FaCss3, FaJs, FaReact } from "react-icons/fa";

export const skillsDatabase = () => {
	return [
		{
			name: "HTML",
			progress: 80,
			icon: <FaHtml5 className='icon html' />,
		},
		{
			name: "CSS",
			progress: 80,
			icon: <FaCss3 className='icon css' />,
		},
		{
			name: "JavaScript",
			progress: 40,
			icon: <FaJs className='icon js' />,
		},
		{
			name: "React JS",
			progress: 40,
			icon: <FaReact className='icon react' />,
		},
	];
};
